/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneColumns as ResolvedStandaloneColumns } from 'base/components/standalone/Columns';

export const Columns: typeof ResolvedStandaloneColumns = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneColumns {...props} />
        </ErrorBoundary>
    );
});

export type ColumnsProps = PropsFromComponent<typeof Columns>;

/** @deprecated Use slot architecture instead */
export const ColumnsWith = (extras: DynamicStandaloneExtras): typeof Columns => {
    return function Columns(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Columns');
        return <ResolvedStandaloneColumns {...mergeProps({ options: { theme } }, props)} />;
    }
}